module.exports = __webpack_public_path__ + "img/cluster3.38fa80d.jpg";